// RegionBarGraph
export const REGION_BAR_GRAPH_LEGENDS = ['#45627B', '#704A71']
export const REGION_BAR_GRAPH_BARS = ['#45627B', '#704A71']
export const REGION_BAR_GRAPH_LINESTROKE = ['#778AA6', '#B6A6BA']
export const REGION_BAR_GRAPH_LABEL = '#ffffff'
// CandleStickGraph
export const NODE_COLOR = '#45627B'
export const MIN_MAX_MARKER_COLOR = 'rgba(69, 98, 123, 1)'
export const MIN_MAX_RECT_FILL_COLOR = 'rgba(80, 128, 144, 0.1)'
export const MIN_MAX_RECT_STROKE_COLOR = 'rgba(69, 98, 123, 1)'
// ScatterPlotWithRegressionLine
export const SCATTERPLOT_NODE_COLOR = [
  'rgba(69, 98, 123, 1)',
  'rgba(112, 74, 113, 0.7)',
]
export const SCATTERPLOT_MIN_MAX_MARKER_COLOR = [
  'rgba(69, 98, 123, 1)',
  'rgba(112, 74, 113, 1)',
]
export const SCATTERPLOT_MIN_MAX_RECT_FILL_COLOR = [
  'rgba(80, 128, 144, 0.1)',
  'rgba(80, 128, 144, 0.1)',
]
